// extracted by mini-css-extract-plugin
export default {"body":"errors_body__JhKFT","error":"errors_error__Lh-Qf","notify":"errors_notify__uH-KZ","fadeOut":"errors_fadeOut__KO4WG"};